import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import TagForm from './TagForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewTagModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.createTag( { tagtext: values.tagtext } )
        .then( ( tag ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( tag );
        } );
    }



    render() {
        const { tag } = this.props;
        return (
            <DLModal title='New Tag'
            closeHandler={ this.props.closeModal }>
                <div>
                    <TagForm next={ this.submitHandler } initialValues={ tag } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createTag: ( data ) => {
            return dAPI.post( '/tags', data );
        },
    };
};

export default connect( null, mapDispatchToProps )( NewTagModal );
